export default "__VITE_ASSET__DlgFKi6J__"